export const dataStatus = [
  { value: 'ACTIVE', label: 'Aktif' },
  { value: 'NON_ACTIVE', label: 'Tidak Aktif' },
];
